import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { actionTypes } from "./actions";

const initialUserState = {
  user: null,
  token: null,
  organization: null,
  fcm_token: null,
  isAuthenticated: false,
  allOrganizations: [],
  customerOf: [],
  portalCustomer: null,
  roles: [],
};

export const reducer = persistReducer(
  {
    storage: storage,
    key: "taskamoon-auth",
    blacklist: [],
  },
  (state = initialUserState, action) => {
    switch (action.type) {
      case actionTypes.LOGIN:
        return {
          ...state,
          user: action.payload.user,
          token: action.payload.token,
        };

      case actionTypes.SET_USER:
        return {
          ...state,
          user: action.payload,
        };

      // A record that already has a `to` is a finished activity, not a running
      // timer: it is normalised away here so no consumer has to re-check it.
      case actionTypes.SET_CURRENT_TRACKING: {
        if (!state.user) return state;

        const record = action.payload?.to ? null : action.payload || null;

        return {
          ...state,
          user: { ...state.user, current_time_tracking: record },
        };
      }

      case actionTypes.SET_FCMTOKEN:
        return {
          ...state,
          fcm_token: action.payload,
        };

      case actionTypes.SET_ORGANIZATION:
        return {
          ...state,
          organization: action.payload,
        };

      case actionTypes.SET_ROLES:
        return {
          ...state,
          roles: action.payload,
        };

      case actionTypes.SET_ALL_ORGANIZATIONS:
        return {
          ...state,
          allOrganizations: action.payload,
        };

      case actionTypes.SET_CUSTOMER_OF:
        return {
          ...state,
          customerOf: action.payload || [],
        };

      case actionTypes.SET_PORTAL_CUSTOMER:
        return {
          ...state,
          portalCustomer: action.payload,
        };

      case actionTypes.SET_AUTHENTICATED:
        return {
          ...state,
          isAuthenticated: action.payload,
        };

      case actionTypes.LOGOUT:
        return initialUserState;

      default:
        return state;
    }
  }
);
